import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IntentSettingsHorizontalMenu, IntentSettingsVerticalTabParam } from 'src/app/modals/intent-settings/constants';
import { VerticalMenuTabsEnum } from 'src/app/modals/intent-settings/enums';
import { GeneralsMenuTabsEnum } from 'src/app/modals/intent-settings/enums/general-menu-tabs.enum';
import { ModalNavigationEnum } from 'src/app/shared/constants';
import { AddonsIdentifiersEnum } from 'src/app/shared/enums';
import { AccountService } from 'src/app/shared/services';

@Component({
    selector: 'app-no-predictiveintent-topics',
    templateUrl: './no-predictiveintent-topics.component.html',
    standalone: false
})
export class NoPredictiveintentTopicsComponent implements OnInit {
    @Input() disabled: boolean = false;
    @Input() intentSource: GeneralsMenuTabsEnum | 'BOTH' = GeneralsMenuTabsEnum.PREDICTIVEINTENT;

    addonsIdentifiersEnum = AddonsIdentifiersEnum;
    availablePlans$: Observable<{ predictiveIntent: boolean, bombora: boolean }>;

    constructor(
        private readonly router: Router,
        private readonly accountService: AccountService
    ) { }

    ngOnInit() {
        this.availablePlans$ = combineLatest([
            this.accountService.hasPlansAsync([AddonsIdentifiersEnum.SALESINTELINTENT]),
            this.accountService.hasPlansAsync([AddonsIdentifiersEnum.BOMBORA_INTENT])
        ]).pipe(
            map(([predictiveIntent, bombora]) => ({ predictiveIntent, bombora }))
        );
    }

    redirectToIntentSettings() {
        this.availablePlans$.pipe(take(1)).subscribe(plans => {
            let targetIntent: GeneralsMenuTabsEnum;

            if (this.intentSource !== 'BOTH') {
                targetIntent = this.intentSource;
            } else if (plans.predictiveIntent && plans.bombora) {
                targetIntent = GeneralsMenuTabsEnum.PREDICTIVEINTENT;
            } else if (plans.predictiveIntent) {
                targetIntent = GeneralsMenuTabsEnum.PREDICTIVEINTENT;
            } else if (plans.bombora) {
                targetIntent = GeneralsMenuTabsEnum.BOMBORA_INTENT;
            } else {
                targetIntent = GeneralsMenuTabsEnum.PREDICTIVEINTENT;
            }

            this.router.navigate(['/', { outlets: { modal: [ModalNavigationEnum.INTENT_SETTINGS] } }], {
                queryParams: {
                    [IntentSettingsVerticalTabParam]: VerticalMenuTabsEnum.GENERAL,
                    [IntentSettingsHorizontalMenu]: targetIntent,
                },
                queryParamsHandling: 'merge'
            });
        });
    }
}
